import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=fbb09308&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb09308",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbb09308')) {
      api.createRecord('fbb09308', component.options)
    } else {
      api.reload('fbb09308', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=fbb09308&scoped=true&", function () {
      api.rerender('fbb09308', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZIOBywhHO3an/JS/comp/SearchFilterTokens.vue"
export default component.exports